import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Button } from 'reactstrap'
import styled from 'styled-components'

import bindActionCreators from '../../../../lib/utils/bindActionCreators'
import getAccessToken from '../../../../lib/utils/getAccessToken'

import NativeDropdown from '../../../../lib/components/NativeDropdown'

import { lobAction } from '../../../../actions'
import { lobSelector } from '../../../../selectors'

import { setFilter } from '../actions'
import { getFilter } from '../selectors'
import { FONTS, COLORS } from '../../../../constants'

const { getLOB } = lobAction
const { getListLOB } = lobSelector

const Root = styled.div`
  display: flex;

  > :first-child {
    margin-right: 6px;
  }

  > :last-child {
    margin-left: 6px;
  }
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: ${props => { return props.bg }};
  width: 100px;
  height: 30px;
  margin-left: 10px;
  color: white;
  border-color: ${props => props.border};
  border-radius: 4px;
  position: relative;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`

/**
 * @typedef {object} Props
 * @property {Array} lobs
 * @property {{ lob: string, project: string, month: number, year: number }} filter
 * @property {typeof getLOB} getLOB
 * @property {typeof setFilter} setFilter
 * @property {typeof clickSearch} clickSearch
 */

/** @extends {Component<Props>} */
export class Filter extends Component {
  /** @type {Props} */
  static defaultProps = {
    lobs: [],
    filter: {},
    getLOB: () => { },
    setFilter: () => { },
  }

  componentDidMount = async () => {
    const { getLOB } = this.props
    await getLOB(getAccessToken())
  }

  /**
   * @param {string} value
   */
  handleLobChange = value => {
    const { setFilter } = this.props
    setFilter('lob', value)
  }

  /**
   * @param {string} value
   */
  handleMonthChange = value => {
    const { setFilter } = this.props
    setFilter('month', parseInt(value))
  }

  /**
   * @param {string} value
   */
  handleYearChange = value => {
    const { setFilter } = this.props
    setFilter('year', parseInt(value))
  }

  handleClickSearch = e => {
    this.props.clickSearch()
  }

  render = () => {
    const { lobs, filter } = this.props

    // Create LOB options
    const lobOptions = [{ label: 'Select LOB', value: '' }].concat(
      lobs.map(data => ({ label: data.name, value: data._id }))
    )
    // Create month options
    const monthOptions = [{ label: 'Select Month', value: '' }].concat(
      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        .map((monthName, index) => ({ label: monthName, value: (index + 1) }))
    )
    // Create year options
    let yearOptions = []
    const currentYear = (new Date()).getFullYear()
    for (var i = 0; i < 5; i++) {
      yearOptions.push({ label: (currentYear - i), value: (currentYear - i) })
    }
    yearOptions = [{ label: 'Select Year', value: '' }].concat(yearOptions)

    return (
      <Root>
        <NativeDropdown value={filter.lob} options={lobOptions} onChange={this.handleLobChange} />
        <NativeDropdown value={filter.month} options={monthOptions} onChange={this.handleMonthChange} />
        <NativeDropdown value={filter.year} options={yearOptions} onChange={this.handleYearChange} />
        <CustomButton bg={COLORS.UPLOAD_COLOR} border={COLORS.UPLOAD_COLOR_BORDER} onClick={this.handleClickSearch}>
          Search
        </CustomButton>
      </Root>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  lobs: getListLOB,
  filter: getFilter,
})

const mapDispatchToProps = bindActionCreators({
  getLOB,
  setFilter,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter)



// WEBPACK FOOTER //
// ./src/pages/report/summary-timesheet/components/Filter.jsx